<template>
  <div class="head-info">
    <div
      v-for="(item, index) in info"
      :key="index"
      class="head-info-cell"
      :style="{ width: item.width || 'auto' }"
    >
      <div class="head-info-title">{{ t(item.title) }}</div>
      <div
        v-for="(cell, cIndex) in item.list"
        :key="cIndex"
        class="head-info-box"
      >
        <div class="head-info-row">
          <div class="head-info-label">{{ t(cell[0]) }}</div><div class="head-info-value">{{ getValue(...cell) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    info: {
      type: Array,
      default: () => []
    },
    prefix: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    t(key) {
      return this.$t(`${this.prefix}.${key}`)
    },
    getValue(key, getVal) {
      if (!getVal) return this.value[key]
      if (typeof getVal === 'function') return getVal(this.value)
      return getVal
    }
  }
}
</script>

<style lang="scss" scoped>
.head-info {
  padding: 10px 0;
  display: flex;
  align-items: stretch;
  &-cell {
    max-width: 40%;
    padding-right: 50px;
  }
  &-title {
    font-size: 14px;
    font-weight: 600;
    color: #666;
    padding: 5px 20px;
  }
  .head-info-cell {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    border-right: 1px solid #F2F2F2;
    &:last-of-type {
      border: none;
    }
  }
  &-box {
    padding: 0 20px;
  }
  &-row {
    padding: 5px 0;
    display: flex;
  }
  &-label {
    padding-right: 15px;
    color: #757575;
    white-space: nowrap;
    width: 80px;
    min-width: 80px;
  }
  &-value {
    color: #333333;
  }
}
</style>
